import styles from "./DesignBoxTabSection.module.css";
import DesignBoxTabEditRow from "./DesignBoxTabEditRow";
const DesignBoxTabSection = ({ buttonHeader, items, activeTabNumber }) => {
  if (!items || items.length === 0) return <></>;
  const rows = [];
  for (let i = 0; i < items.length; i += 4) {
    rows.push(items.slice(i, i + 4));
  }
  console.log(rows);
  return (
    <div className={styles.tab_section_main_div}>
      <div className={styles.tab_section_button}>
        <button>{buttonHeader}</button>
      </div>
      <div className={styles.tab_section_items}>
        {Array.isArray(rows) &&
          rows.length > 0 &&
          rows.map((row, index) => {
            return (
              <DesignBoxTabEditRow
                key={index}
                items={row}
                activeTabNumber={activeTabNumber}
              />
            );
          })}
      </div>
    </div>
  );
};
export default DesignBoxTabSection;
